import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export function parseHelperItems(helperItems) {
  if (Array.isArray(helperItems)) {
    return helperItems
      .map((item) => String(item || '').trim())
      .filter(Boolean);
  }

  return String(helperItems || '')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);
}

const HelpModal = ({ show, onHide, helperItems }) => {
  const items = parseHelperItems(helperItems);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Help & Troubleshooting</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="px-3 pb-3">
          {items.map((item, index) => (
            <li className="pb-3" key={`${item}-${index}`}>
              {item}
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HelpModal;
